import { SearchResultWithSnippet } from "./types";
import { track } from '@vercel/analytics';

type Props = {
    result: SearchResultWithSnippet;
    position: number;
    urlPrefix?: string;
    linkTarget?: string;
    parentOrigin: string | undefined;
};

export const ChatReference = ({
  result,
  position,
  urlPrefix,
  linkTarget,
  parentOrigin,
}: Props) => {

  let url = result.document_metadata.url as string;
  if (urlPrefix && urlPrefix.length > 0) {
      url = urlPrefix + url;
  }
  const title = result.document_metadata.title as string;
  const image = result.document_metadata.image_url as string;
  const text = result.snippet.text;
  const tagStr = result.document_metadata.tags as string ?? '';
  const tags = tagStr.split(',');
  const firstTag = (tags.length > 0) ? tags[0] : undefined;
  // console.log(result);

  return (
    <a
      href={url}
      target={linkTarget}
      className="chatSearchResult"
      onClick={ (result) => track('Result:Click', { id: result.document_id, host: parentOrigin }) }
    >
      {/*<span className="chatSearchResultPosition"><span>{position + 1}</span></span>*/}
      <div className="chatSearchResultImage">
        {firstTag && (
          <span className="chatSearchResultBanner">{firstTag}</span>
        )}
        <img src={image} alt={title}/>
      </div>
      <div className="chatSearchResultSnippet">
        <h3 className="chatSearchResultTitle">{title}</h3>
        <p className="chatSearchResultDescription">{text}</p>
      </div>
    </a>
  );
};
